import {observable} from "mobx";
import ProjectVersionDoor from "../domain/project/projectVersionDoorDomain";
import {Promise} from "axios";
import mdAxios from "../../core/common/config/axios-config";
import {IDomainObject} from "../../core/form/formUtils";


class ProjectVersionDoorService {

  @observable public projectVersionDoorObject : ProjectVersionDoor;

  readProjectVersionDoor(projectVersionDoorId: number) : Promise<ProjectVersionDoor> {
    return mdAxios.get("sbtool/project-version/doors/" + projectVersionDoorId)
      .then(response => new ProjectVersionDoor(response.data));
  }

  saveProjectVersionDoor(projectVersionId: number, door : ProjectVersionDoor): Promise<IDomainObject> {
    return mdAxios.post('sbtool/project-version/' + projectVersionId + "/doors", door)
      .then((response) => response.data);
  }

  deleteProjectVersionDoor(doorId : number): Promise<void> {
    return mdAxios.delete("sbtool/project-version/doors/" + doorId)
      .then(response => {});
  }

}

const projectVersionDoorService = new ProjectVersionDoorService();
export default projectVersionDoorService;



// WEBPACK FOOTER //
// ./src/sbtool/service/projectVersionDoorService.ts